import {useTranslation} from 'react-i18next'
import {Button} from '../../../Components/Atoms/Buttons'
import React from 'react'
import {IconChatBot} from '../../../Assets/Icons/TinyIcons'

interface AidaMinimizedWindowProps {
  onClick: () => void
}

const MinimizedBubble = ({onClick}: AidaMinimizedWindowProps) => {
  const {t} = useTranslation('aida')
  return (
    <Button
      style={{
        width: '20vw',
        height: '5vh',
        borderTopRightRadius: '12px',
        borderTopLeftRadius: '12px',
        borderBottomRightRadius: '0%',
        borderBottomLeftRadius: '0%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
      onClick={onClick}
    >
      <span style={{textAlign: 'left', flexGrow: '1'}}>{t('aida:minimizedHeading', 'Kysy Aidalta')}</span>
      <span>
        <IconChatBot />
      </span>
    </Button>
  )
}

export default MinimizedBubble
